import {ClientInfoResponseData} from "../../../types/client";
import React, {useEffect, useState} from "react";
import {clientInfoAPI} from "../../../services/client";
import {UserIcon} from "@heroicons/react/24/solid";
import styles from "./ClientAccountCard.module.css";
import Button from "../../common/button/Button";
import BusinessLicensePopUp from "../../../views/admin/popup/BusinessLicensePopUp";

interface ClientAccountCardProps {
    onModify: () => void;
}

//클라이언트 계정 정보 조회
const ClientAccountCard: React.FC<ClientAccountCardProps> = ({onModify}) => {
    const [data, setData] = useState<ClientInfoResponseData | null>(null);
    const [loading, setLoading] = useState(true);
    const [isLicenseOpen, setIsLicenseOpen] = useState(false);

    //클라이언트 사업자등록증 팝업 닫기
    const handleCloseLicenseModal = () => {
        setIsLicenseOpen(false);
        fetchData();
    }


    const fetchData = async () => {
        try {
            setLoading(true);
            // 클라이언트 계정 정보 조회 API
            const response = await clientInfoAPI();
            setData(response);
        } catch (error) {
            console.error('Error fetching account:', error);
        } finally {
            setLoading(false);
        }
    }

    //사업자등록증 팝업 열기
    const handleOpenLicenseModal = () => {
        setIsLicenseOpen(true);
    }

    useEffect(() => {
        fetchData();
    }, []);

    if (loading || !data) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.cardWrapper}>
                <div className={styles.accountCard}>
                    <div className={styles.header}>
                        <div className={styles.headerContent}>
                            <div className={styles.titleSection}>
                                <UserIcon className={styles.userIcon}/>
                                <h1 className={styles.title}>계정 정보</h1>
                            </div>
                            {/*수정 버튼*/}
                            <Button onClick={onModify} variant="primary">
                                수정
                            </Button>
                        </div>
                    </div>

                    <div className={styles.content}>
                        <div className={styles.gridContainer}>
                            <h3 className={styles.info}>기업 정보</h3>
                            <div className={styles.line}/>
                            <div className={styles.infoGrid}>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>회사명</span>
                                    <span className={styles.value}>{data.companyName}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>대표자 성명</span>
                                    <span className={styles.value}>{data.name}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>사업자등록번호</span>
                                    <span className={styles.value}>{data.businessNumber}</span>
                                </div>
                                {/* 개인정보 동의한 경우에만 업태, 종목, 사업장 소재지 표시 */}
                                {data.optional && (
                                    <>
                                        <div className={styles.infoItem}>
                                            <span className={styles.label}>업태</span>
                                            <span className={styles.value}>{data.type}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.label}>종목</span>
                                            <span className={styles.value}>{data.item}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.label}>사업장 소재지</span>
                                            <span className={styles.value}>{data.address}</span>
                                        </div>
                                    </>
                                )}
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>사업자등록증</span>
                                    {/*클라이언트 사업자등록증 조회 버튼*/}
                                    <span className={styles.value}>
                                    <Button
                                        variant="primary"
                                        onClick={handleOpenLicenseModal}
                                    >
                                        보기
                                    </Button>
                                </span>
                                </div>
                            </div>
                        </div>

                        <div className={styles.gridContainer}>
                            <h3 className={styles.info}>계정 정보</h3>
                            <div className={styles.line}/>
                            <div className={styles.infoGrid}>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>ID</span>
                                    <span className={styles.value}>{data.userName}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>개인정보 수집·이용 동의 여부</span>
                                    <span className={styles.value}>{data.optional ? '동의' : '미동의'}</span>
                                </div>
                            </div>
                        </div>

                        <div className={styles.gridContainer}>
                            <h3 className={styles.info}>담당자 정보</h3>
                            <div className={styles.line}/>
                            <div className={styles.infoGrid}>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>담당자 성명</span>
                                    <span className={styles.value}>{data.managerName}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>담당자 전화번호</span>
                                    <span className={styles.value}>{data.phoneNumber}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>Email</span>
                                    <span className={styles.value}>{data.email}</span>
                                </div>
                                {/* 개인정보 동의한 경우에만 부서와 직위 표시 */}
                                {data.optional && (
                                    <>
                                        <div className={styles.infoItem}>
                                            <span className={styles.label}>담당자 부서</span>
                                            <span className={styles.value}>{data.department}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.label}>담당자 직위</span>
                                            <span className={styles.value}>{data.position}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*사업자등록증 조회 팝업*/}
            <BusinessLicensePopUp
                isOpen={isLicenseOpen}
                onClose={handleCloseLicenseModal}
            />
        </div>
    );
}

export default ClientAccountCard;